import React, { PropTypes } from 'react';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { PrimaryButton } from '@bibliocommons/base-buttons';
import AddToShelfComboButton from '../../AddToShelfComboButton';

import './BatchAddToShelfButton.scss';

export default class BatchAddToShelfButton extends BcReactComponent {

  render() {
    const { selectedItemCount, isLoading, handleClick } = this.props;
    return (
      <div className="cp-batch-add-to-shelf-button">
        <AddToShelfComboButton
          handleClick={handleClick}
          disabled={selectedItemCount === 0}
          isLoading={isLoading}
          ButtonTag={PrimaryButton}>
          {selectedItemCount > 0 ? ` (${selectedItemCount})` : ''}
        </AddToShelfComboButton>
      </div>
    );
  }
}

BatchAddToShelfButton.propTypes = {
  handleClick: PropTypes.func,
  selectedItemCount: PropTypes.number,
  isLoading: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/components/shared/BatchActions/BatchAddToShelfButton/BatchAddToShelfButton.jsx